import { call, put } from 'redux-saga/effects';
import { searchBillingEntities, toggleBillingEntity } from '../requests/billingEntities';
import { showAlert } from '../../slices/alerts';
import { safeErrorMessage } from '../../../utils/errorUtils';

export function* handleSearchBillingEntities(action) {
    try {
        const { query, billingOnly, callback, includeNonEntities } = action.payload;
        const response = yield call(searchBillingEntities, query, billingOnly, includeNonEntities);
        if (callback) callback(response.data);
    } catch (error) {
        yield put(showAlert({ severity: 'error', message: safeErrorMessage(error) }));
        if (action.payload?.callback) {
            action.payload.callback({ clients: [], matchedVia: {} });
        }
    }
}

export function* handleToggleBillingEntity(action) {
    try {
        const { entityType, entityId, billingEntity, callback } = action.payload;
        const response = yield call(toggleBillingEntity, entityType, entityId, billingEntity);
        if (callback) callback({ ok: true, data: response.data });
    } catch (error) {
        const message = safeErrorMessage(error);
        yield put(showAlert({ severity: 'error', message }));
        if (action.payload?.callback) {
            action.payload.callback({ ok: false, message });
        }
    }
}
